import React from 'react';
import Classes from 'classnames';
import UserIcon from "core/gd-components/icons/user/user";


export default function SystemFieldUserViewInImport(props) {

    const user = gd.session.users.get(props.value);
    // <img src="https://www.goodday.work/media/user/small/uUiAHy.jpeg" alt="" className="avatar-22 " />

    return (

        <div className="ui5-chip s22 gray user">
            <UserIcon size="22" userId={props.value} className="user-icon"/>
            <div className="label">{user.name}</div>
        </div>
    );
}